import React, { useEffect } from 'react';
import style from "./css/aboutPage.module.css";

interface AboutPageProps {

}

const AboutPage: React.FC<AboutPageProps> = () => {
    const changeNavStyle = () => {
        document.documentElement.style.setProperty('--nav-text-color', 'black');
        document.documentElement.style.setProperty('--pseudo-nav-display', 'flex');
    };

    const setAboutSelected = () => {

        document.getElementById('AboutUs')?.classList.add("selected");
    }

    useEffect(() => {
        changeNavStyle();
        setAboutSelected();
    }, [])
    return (
        <>

            <div className={style.aboutMain}>
                <p className={style.aboutMainTitle}>
                    Welcome to Michis Picks
                    Where Winning Moves Are Made.
                </p>

                <div className={style.aboutSection1}>
                    <p className={style.aboutSection1_p}>
                        At Michis Picks, we’re not just about betting; we’re about transforming the way you play the game. Founded by Michi $ande, a passionate sports enthusiast with years of experience and a sharp eye for the odds, Michis Picks offers more than just tips – we deliver a winning strategy. Our mission is to bring the thrill and precision of Vegas betting directly to you, wherever you are.
                    </p>
                    <img src="/media/family.png" alt="" className={style.aboutSection1_img} />
                </div>

                <div className={style.aboutSection2}>
                    <h3 className={style.aboutSection2_title}>What We Offer</h3>
                    <div className={style.aboutSection2_des}>
                        <p className={style.des_title}>
                            Daily Winning Picks
                        </p>
                        <p className={style.des_body}>
                            Michi and his team dive deep into the stats, trends, and insider information to bring you top-tier picks every day. With Michis Picks, you’re always a step ahead of the game.
                        </p>
                    </div>
                    <div className={style.aboutSection2_des}>
                        <p className={style.des_title}>
                            VIP Experience
                        </p>
                        <p className={style.des_body}>
                            Unlock access to exclusive picks and strategies that are reserved for the elite. We don’t just follow the trends; we set them.
                        </p>
                    </div>

                    <div className={style.aboutSection2_des}>
                        <p className={style.des_title}>
                            Referral Program
                        </p>
                        <p className={style.des_body}>
                            We believe in the power of community. With our unique referral program, you can boost your earnings while sharing the winning formula with others. It’s not just about betting smarter; it’s about betting together.
                        </p>
                    </div>


                </div>


                <div className={style.aboutSection3}>
                    <div className={style.aboutSection3_body}>
                        <h4 className={style.aboutSection3_body_h4}>
                            Our Story
                        </h4>


                        <p className={style.aboutSection3_body_text}>
                            Michis Picks was born out of Michi $ande’s passion for sports and a desire to elevate the betting experience. Michi knows that the world of sports betting can be overwhelming, but with the right guidance, it can also be incredibly rewarding. That’s why Michi is here – to provide you with the tools, knowledge, and confidence to make winning moves.
                        </p>


                        <p className={style.aboutSection3_body_endText}>
                            Join Michi $ande and the Michis Picks
                            community, and let’s crush the game
                            together
                        </p>
                    </div>
                    <div className={style.aboutSection3ImageSplit}>

                        <p className={style.aboutSection3_body_endTextMobile}>
                            Join Michi $ande and the Michis Picks
                            community, and let’s crush the game
                            together
                        </p>
                        <img src="/media/mrSander.png" alt="" className={style.image} />


                    </div>
                </div>
            </div>

        </>
    );
};

export default AboutPage;